import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/models/api-response.model';
import { FasttrackPromotionLogs } from '@core/models/fasttrack-promotion-logs.model';
import { Pagination } from '@core/models/pagination.model';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FasttrackPromotionLogsDataService {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(
    private http: HttpClient
  ) { }

  getWithQuery(params: string): Observable<FasttrackPromotionLogs[]> {
    return this.http.get<ApiResponse>(`/fasttrack/bonus-log?${params}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
